export default __webpack_public_path__ + "static/teamphoto-7b4f3c9f3c2c18428aa88cbe99c89ca9.png";